/**
 *  App class
 *
 *  The App class functions a the main back-bone of the javascript used in this
 *  project.
 *
 *  @param { number } aX
 *  @param { number } aY
 */
class App {
    constructor() {
        const mobmenuTrigger = document.getElementById('menu-toggle')
        const mobileMenu = document.getElementById('mobile-menu')
        const headerMenu = document.getElementById('header-menu')
        const submenuItems = document.querySelectorAll('.menu-main__menu-item.has--children')
        const menuBackButtons = document.querySelectorAll('.menu-backbutton')

        const toggleClass = (element, className) => {
            element.classList.toggle(className)
        }

        if (mobmenuTrigger) {
            mobmenuTrigger.addEventListener('click', function () {
                toggleClass(this, 'active')
                toggleClass(mobileMenu, 'active')
                toggleClass(headerMenu, 'active')
            })
        }

        if (submenuItems) {
            submenuItems.forEach((element) => {
                element.addEventListener('click', function (event) {
                    if (element !== event.target) return
                    toggleClass(this, 'active')
                })
            })
        }

        if (menuBackButtons) {
            menuBackButtons.forEach((element) => {
                element.addEventListener('click', function () {
                    this.closest('.menu-main__menu-item.has--children').classList.remove('active')
                })
            })
        }
    }
}

window.app = new App()
